module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-5-10aba888fa2d6189eeeafd5535ace285.svg";